import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import './Toggle.scss'

const Toggle = ({ label = '', value, onUpdate, isDisabled, sliderWrapperClassName }) => {
    const { t } = useTranslation()
    const onChange = () => {
        if (isDisabled) return
        onUpdate(!value)
    }

    return (
        <div className="common-toggle">
            <div
                className={classNames('common-toggle__slider-wrapper', {
                    'common-toggle__slider-wrapper--is-unchecked': !value,
                    [sliderWrapperClassName]: !!sliderWrapperClassName,
                })}
            >
                <span
                    className={classNames('common-toggle__slider', { checked: value })}
                    onClick={onChange}
                    title={value ? t('Disable') : t('Enable ')}
                />
            </div>
            {!!label && (
                <p className="common-toggle__label" onClick={onChange}>
                    {label}
                </p>
            )}
        </div>
    )
}

export default Toggle
